import { render, staticRenderFns } from "./lclForm.vue?vue&type=template&id=e8cb34d6&"
import script from "./lclForm.vue?vue&type=script&lang=js&"
export * from "./lclForm.vue?vue&type=script&lang=js&"
import style0 from "./lclForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8cb34d6')) {
      api.createRecord('e8cb34d6', component.options)
    } else {
      api.reload('e8cb34d6', component.options)
    }
    module.hot.accept("./lclForm.vue?vue&type=template&id=e8cb34d6&", function () {
      api.rerender('e8cb34d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceLCL/components/lclForm.vue"
export default component.exports